export const calendarCopilotCharmAriaLabel = "WlJoIc";
export default {calendarCopilotCharmAriaLabel};